import { Link } from "gatsby"
import React from "react"

interface TopBannerProps {
  link?: string
  hideOnMobile?: boolean
  isExternalLink?: boolean
  children: React.ReactNode
}

export default function TopBanner(props: TopBannerProps) {
  const { hideOnMobile = false, link, children, isExternalLink } = props

  const baseClassnames = "h-6 flex items-center justify-center text-center bg-black z-50 group"
  const bannerClassnames = hideOnMobile ? `se:hidden phablet:hidden tablet:hidden ${baseClassnames}` : baseClassnames
  const banner = <div className={bannerClassnames}>{children}</div>

  if (link && !isExternalLink) return <Link to={link}>{banner}</Link>
  if (link && isExternalLink) {
    return (
      <a href={link} rel="noopener noreferrer" target="_blank">
        {banner}
      </a>
    )
  }

  return banner
}
